// 静态菜单配置（后续切动态权限时改为从接口获取）
const STATIC_MENU_TREE = [
  // {
  //   authId: 10,
  //   authName: '商户管理',
  //   authIcon: 'el-icon-tickets',
  //   authType: '0',
  //   children: [
  //     { authId: 11, authName: '商户订单', authUrl: '/order/list', authIcon: 'el-icon-tickets', authType: '1', children: [] },
  //     { authId: 22, authName: '商户用户', authUrl: '/system/userShop', authIcon: 'el-icon-user', authType: '1', children: [] }
  //   ]
  // },
  {
    authId: 10,
    authName: '商户订单',
    authUrl: '/order/list',
    authIcon: 'el-icon-tickets',
    authType: '0'
  },
  {
    authId: 15,
    authName: '商户用户',
    authUrl: '/system/userShop',
    authIcon: 'el-icon-user',
    authType: '0'
  },
  {
    authId: 50,
    authName: '水电费管理',
    authIcon: 'el-icon-document',
    authType: '0',
    children: [
      { authId: 51, authName: '提交记录', authUrl: '/utility-bill/list', authIcon: 'el-icon-document', authType: '1', children: [] }
    ]
  },
  {
    authId: 20,
    authName: '系统管理',
    authIcon: 'el-icon-setting',
    authType: '0',
    children: [
      { authId: 21, authName: '用户管理', authUrl: '/system/user', authIcon: 'el-icon-user', authType: '1', children: [] },
      { authId: 22, authName: '商户地市', authUrl: '/system/shopCity', authIcon: 'el-icon-office-building', authType: '1', children: [] }
    ]
  },
  {
    authId: 30,
    authName: '日志管理',
    authIcon: 'el-icon-document',
    authType: '0',
    children: [
      { authId: 31, authName: '操作日志', authUrl: '/system/log', authIcon: 'el-icon-document', authType: '1', children: [] },
      { authId: 32, authName: '日志归档', authUrl: '/system/fullLog', authIcon: 'el-icon-files', authType: '1', children: [] },
      { authId: 33, authName: '日志统计', authUrl: '/system/logStatistics', authIcon: 'el-icon-data-analysis', authType: '1', children: [] }
    ]
  },
  {
    authId: 40,
    authName: '消息管理',
    authIcon: 'el-icon-bell',
    authType: '0',
    children: [
      { authId: 41, authName: '通知管理', authUrl: '/system/notice', authIcon: 'el-icon-bell', authType: '1', children: [] },
      { authId: 42, authName: '短信记录', authUrl: '/system/smsRecord', authIcon: 'el-icon-message', authType: '1', children: [] }
    ]
  }
]

// 管理菜单的 authId 集合，仅 auId 为 1 或 2 的用户可见
const ADMIN_MENU_IDS = [20, 30, 40, 50]

// 根据用户 auId 过滤菜单树
function filterMenuByUser (auId) {
  const isAdmin = auId === 1 || auId === 2
  if (isAdmin) return STATIC_MENU_TREE
  return STATIC_MENU_TREE.filter(item => !ADMIN_MENU_IDS.includes(item.authId))
}

const state = {
  menuTree: STATIC_MENU_TREE,
  routesGenerated: true
}

const mutations = {
  SET_MENU_TREE (state, tree) {
    state.menuTree = tree || STATIC_MENU_TREE
  }
}

const actions = {
  // 根据用户信息生成可见菜单
  generateMenu ({ commit }, userInfo) {
    const auId = userInfo && userInfo.auId
    const tree = auId ? filterMenuByUser(auId) : STATIC_MENU_TREE
    commit('SET_MENU_TREE', tree)
  },
  resetPermission ({ commit }) {
    commit('SET_MENU_TREE', STATIC_MENU_TREE)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
